import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Snowflake,
  AirVent,
  Wrench,
  Wind,
  Phone,
  ChevronRight,
} from 'lucide-react';
import './Services.css';

const SERVICES = [
  {
    num: '01',
    title: 'Climatisation',
    slug: 'climatisation',
    path: '/climatisation',
    icon: <Snowflake size={32} strokeWidth={1.6} />,
    desc: 'Installation et maintenance de climatiseurs splits, multi-splits et systèmes gainables pour une régulation thermique optimale.',
    items: ['Split mural', 'Multi-split', 'Gainable', 'Cassette plafond', 'Console'],
    color: '#1d4ed8',
    bgClass: 'srv-bg-1',
  },
  {
    num: '02',
    title: 'Pompe à chaleur',
    slug: 'pompe-chaleur',
    path: '/pompe-a-chaleur',
    icon: <AirVent size={32} strokeWidth={1.6} />,
    desc: 'Solutions éco-responsables de pompe à chaleur air-air et air-eau pour un chauffage et rafraîchissement économiques.',
    items: ['PAC air-air', 'PAC air-eau', 'Réversible', 'Plancher chauffant', 'Radiateurs basse température'],
    color: '#c8102e',
    bgClass: 'srv-bg-2',
  },
  {
    num: '03',
    title: 'Ventilation',
    slug: 'ventilation',
    path: '/ventilation',
    icon: <Wind size={32} strokeWidth={1.6} />,
    desc: "Installation, entretien et remplacement de systèmes de ventilation pour assurer une circulation d'air saine et efficace dans vos espaces.",
    items: ['VMC simple flux', 'VMC double flux', 'Ventilation hygroréglable', "Extraction d'air", 'Entretien ventilation'],
    color: '#0f766e',
    bgClass: 'srv-bg-3',
  },
  {
    num: '04',
    title: 'Entretien',
    slug: 'entretien',
    path: '/entretien-climatisation',
    icon: <Wrench size={32} strokeWidth={1.6} />,
    desc: 'Entretien annuel, dépannage et réparation toutes marques. Contrats de maintenance pour entreprises et copropriétés.',
    items: ['Entretien annuel', 'Dépannage urgence', 'Nettoyage filtres', 'Contrat maintenance', 'Recharge fluide'],
    color: '#0a2463',
    bgClass: 'srv-bg-4',
  },
];

export default function Services() {
  const [active, setActive] = useState(0);

  return (
    <section id="services" className="services">
      <div className="srv-header container">
        <div className="srv-eyebrow">
          <span />NOS SERVICES
        </div>
        <h2 className="srv-title">
          DES SOLUTIONS POUR
          <br />
          <span className="srv-title-red">CHAQUE BESOIN</span>
        </h2>
      </div>

      <div className="container">
        <div className="srv-layout">
          <div className="srv-list">
            {SERVICES.map((s, i) => (
              <button
                key={s.slug}
                type="button"
                className={`srv-item${active === i ? ' srv-item--on' : ''}`}
                style={{ '--c': s.color }}
                onClick={() => setActive(i)}
              >
                <div className="srv-item-left">
                  <div className="srv-item-icon">{s.icon}</div>
                  <div className="srv-item-text">
                    <span className="srv-item-num">{s.num}</span>
                    <span className="srv-item-name">{s.title}</span>
                  </div>
                </div>
                <ChevronRight size={18} strokeWidth={2} className="srv-item-arrow" />
              </button>
            ))}
          </div>

          {SERVICES.map((s, i) => (
            <div
              key={s.slug}
              className={`srv-panel ${s.bgClass}${active === i ? ' srv-panel--on' : ''}`}
            >
              <div className="srv-panel-overlay" />

              <div className="srv-panel-body">
                <div className="srv-panel-icon" style={{ background: s.color }}>
                  {s.icon}
                </div>

                <h3 className="srv-panel-title">{s.title}</h3>
                <p className="srv-panel-desc">{s.desc}</p>

                <ul className="srv-panel-list">
                  {s.items.map((item) => (
                    <li key={item}>
                      <span style={{ background: s.color }} />
                      {item}
                    </li>
                  ))}
                </ul>

                <div className="srv-panel-footer">
                  <button
                    type="button"
                    className="srv-btn-devis"
                    onClick={(e) => { e.stopPropagation(); document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' }); }}
                  >
                    Demander un devis
                  </button>
                  <a href="tel:0618011895" className="srv-btn-tel" onClick={(e) => e.stopPropagation()}>
                    <Phone size={14} strokeWidth={2} />
                    06 18 01 18 95
                  </a>
                  <Link to={s.path} className="about__more-btn" onClick={(e) => e.stopPropagation()}>
                    <span className="about__more-btn-dash" />
                    En savoir plus
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}